export enum ConsultantEventType {
  Comment = "Comment",
  QualityUpdate = "QualityUpdate",
  Document = "Document",
  Email = "Email",
  Call = "Call",
  Noanswer = "Noanswer",
  MetInPerson = "MetInPerson",
  Registered = "Registered",
  Reminder = "Reminder",
  SMS = "SMS",
  SystemLog = "SystemLog",
  ConsultantApp = "ConsultantApp",
  /** @description Intresseanmälan */
  Interest = "Interest",
  GDPR = "GDPR",
  UserSettings = "UserSettings",
  WelcomeEmail = "WelcomeEmail",
  /**
   * @description A marketing email or SMS an external sender reports as sent.
   * A receipt, not a contact: it moves neither the last-contact date nor the
   * no-answer counters.
   */
  MarketingMessage = "MarketingMessage"
}

export const noAnswerEventTypes = [
  ConsultantEventType.Email,
  ConsultantEventType.SMS,
  ConsultantEventType.Noanswer
];
